import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-needs-copapp',
  templateUrl: './needs-copapp.component.html',
  styles: [
    'table {display:block; margin-bottom:1em}',
    '.mat-mdc-table {width: 100%;max-height: 500px;overflow: auto;}',
    'tr.element-row:hover{background: whitesmoke}',
	  'a {text-decoration: none;}',
    '.loading-shade {position: absolute;top: 0;left: 0;bottom: 56px;right: 0;background: rgba(136, 134, 134, 0.15);z-index: 1;display: flex;align-items: center;justify-content: center;}'
  ]
})
export class NeedsCopappComponent {
  @ViewChild('paginator') paginator:MatPaginator;
  @Output() sendNeedsCoApp = new EventEmitter<any>();
  constructor(private apiService:LegacyApiService){}
    ncpColumns: string[] = ['name', 'province','agencyName', 'note'];
    dataSourceNeedsCoApp:MatTableDataSource<string[]>;
    isLoading = true;
    totalNeedsCoApp:number;
    serviceSubscription:Subscription;
    async ngAfterViewInit(): Promise<void> {
      this.dataSourceNeedsCoApp = new MatTableDataSource(await this.needsCoApp(['Needs Co-App']));
      this.dataSourceNeedsCoApp.paginator=this.paginator;
      this.totalNeedsCoApp=this.dataSourceNeedsCoApp.filteredData?.map((item:any)=>item.Amount).reduce((prev,next)=>prev+next,0);
      this.sendTotalCountandAmount(this.dataSourceNeedsCoApp?.filteredData.length,this.totalNeedsCoApp);
    };
    needsCoApp(stageName):Promise<any>{
      return new Promise((resolve,reject)=>{
        this.isLoading=true;
        this.serviceSubscription=this.apiService.underwritingDashboardQueues(stageName).subscribe((res:any) => {
          if (res.message.statusCode === 200) {
            const arr = JSON.parse(res.message.body);
            this.isLoading=false;
            resolve(arr.data);
          }else{
            this.isLoading=false;
            resolve([])
          }
        })
      })
    }

  sendTotalCountandAmount(count:number,amount:number){
    const result = {count:count,amount:amount};
    this.sendNeedsCoApp.emit(result);
  }

  ngOnDestroy() {
    this.serviceSubscription.unsubscribe();
  }
}
